import React, {useState} from 'react'
import {Modal} from '@therms/atalaya'
import {CreateEventForm} from '@therms/react-modules'
import {PickEventType} from '@src/modules/Events/components/PickEventTypeModal'

interface NewEventModalProps {
  closeHandler: (eventId?: string) => void
}

function NewEventModal({closeHandler}: NewEventModalProps) {
  const [eventTypeId, setEventTypeId] = useState<string>()

  if (!eventTypeId) {
    return (
      <Modal closeHandler={closeHandler} escPressClose header="New Event">
        <PickEventType onSelectEventType={setEventTypeId} />
      </Modal>
    )
  }

  return (
    <Modal closeHandler={closeHandler} header="New Event" width="lg">
      <CreateEventForm eventTypeId={eventTypeId} onComplete={closeHandler} />
    </Modal>
  )
}

export {NewEventModal}
